import {
  SORT_OPTIONS,
  STATUS_OPTIONS,
  type SortKey,
  type StatusKey,
} from "@/utils/comicFilter";

interface ComicFiltersProps {
  genres: string[];
  activeGenres: string[];
  onToggleGenre: (genre: string) => void;
  status: StatusKey;
  onStatusChange: (status: StatusKey) => void;
  sort: SortKey;
  onSortChange: (sort: SortKey) => void;
  onReset: () => void;
}

export default function ComicFilters({
  genres,
  activeGenres,
  onToggleGenre,
  status,
  onStatusChange,
  sort,
  onSortChange,
  onReset,
}: ComicFiltersProps) {
  const segCls = (active: boolean) =>
    `px-3 h-9 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
      active
        ? "bg-primary-500 text-background-50"
        : "bg-background-50 border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
    }`;

  return (
    <div className="rounded-xl bg-background-50 border border-background-200 p-4 md:p-5 flex flex-col gap-5">
      <div>
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-heading font-bold text-sm text-foreground-900">
            <i className="ri-price-tag-3-line mr-1.5 text-primary-500"></i>
            题材筛选（可多选）
          </h3>
          <button
            type="button"
            onClick={onReset}
            className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-refresh-line"></i>
            重置筛选
          </button>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => activeGenres.forEach((g) => onToggleGenre(g))}
            className={segCls(activeGenres.length === 0)}
          >
            全部题材
          </button>
          {genres.map((genre) => (
            <button
              key={genre}
              type="button"
              onClick={() => onToggleGenre(genre)}
              className={segCls(activeGenres.includes(genre))}
            >
              {genre}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm text-foreground-500">排序：</span>
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100">
            {SORT_OPTIONS.map((opt) => (
              <button
                key={opt.key}
                type="button"
                onClick={() => onSortChange(opt.key)}
                className={`px-3 h-8 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  sort === opt.key
                    ? "bg-background-50 text-primary-600 font-medium"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm text-foreground-500">状态：</span>
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100">
            {STATUS_OPTIONS.map((opt) => (
              <button
                key={opt.key}
                type="button"
                onClick={() => onStatusChange(opt.key)}
                className={`px-3 h-8 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  status === opt.key
                    ? "bg-background-50 text-primary-600 font-medium"
                    : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}